import axios from "axios";

export const api = axios.create({
  // baseURL: "https://api-sushizeira.herokuapp.com",
  baseURL: "https://capstone-sushizera.herokuapp.com",
});
